// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._4TpfbpL6x{}._4TpfbpL6x>*:not(:last-child){margin-right:8px}._5viQUZkfx{flex-shrink:1}._70TyVwBSx{}._70TyVwBSx ._2hr6xf0jx{margin-left:8px;flex-shrink:9999999}@media screen and (-ms-high-contrast: black-on-white){._4TpfbpL6x:not(._6KEXCV7gx) ._7G1wbxfgx,._70TyVwBSx:not(._6KEXCV7gx) ._7G1wbxfgx{color:currentColor}}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"item": "_4TpfbpL6x " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"title": "_5viQUZkfx",
	"inline": "_70TyVwBSx _4TpfbpL6x " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"description": "_2hr6xf0jx",
	"disabled": "_6KEXCV7gx",
	"text": "_7G1wbxfgx"
};
module.exports = exports;
